<template>
  <ec-dialog :dialog.sync="visible">
    <template v-slot:title>{{$t('FilterIncomes')}}</template>
    <template v-slot:right>
      <v-btn color="primary" class="my-2" @click="apply()" :disabled="!formIsValid">{{$t('Apply')}}</v-btn>
    </template>
    <template>
      <div class="d-flex px-4 py-2 justify-end">
        <v-btn
          color="primary"
          :block="$vuetify.breakpoint.smAndDown"
          outlined
          @click="resetFilter()"
        >{{$t("Reset")}}</v-btn>
      </div>
      <div class="px-4 py-2">
        <v-form ref="form" v-model="formIsValid" :key="key">
          <v-row class="mb-0">
            <v-col cols="12" md="6" class="py-0">
              <v-select
                :items="dictionaries.transactionTypeEnum"
                item-text="description"
                item-value="code"
                v-model="model.transactionType"
                :label="$t('TransactionType')"
                outlined
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <terminal-select v-model="model.terminalID" clearable></terminal-select>
            </v-col>
            <!-- <v-col cols="12" md="6" class="py-0">
              <v-select
                ref="quickDate"
                :items="dictionaries.quickDateFilterTypeEnum"
                item-text="description"
                item-value="code"
                v-model="model.quickDateFilter"
                :label="$t('PayDate')"
                outlined
                clearable
              ></v-select>
            </v-col> -->
            <date-from-to-filter
              ref="dateFromTo"
              class="px-3 py-0" 
              style="margin-top: -12px !important" 
              v-model="model"
              @change=resetQuickDateFilter()>
           </date-from-to-filter>
          </v-row>
        </v-form>
      </div>
    </template>
  </ec-dialog>
</template>
  
  <script>
import FilterMixin from "@/extensions/mixins/FilterMixin";
import ValidationRules from "../../helpers/validation-rules";
import {mapState} from "vuex";
import moment from "moment";
  
export default {
  name: "MerchantsFilter",
  components: {
    EcDialog: () => import("../ec/EcDialog"),
    DateFromToFilter: () => import("../filtering/DateFromToFilter"),
  },
  mixins: [FilterMixin],
  props: {
    selectedPeriod: {
      type: String,
      default: "",
    },
  },  
  data() {
    return {
      transactionTypeEnumLang: {
        'en-IL': [
          {
            code: this.$appConstants.transaction.types.regularDeal,
            description: 'Regular Deal',
          },
          {
            code: this.$appConstants.transaction.types.installments,
            description: 'Installments',
          },
          {
            code: this.$appConstants.transaction.types.credit,
            description: 'Credit',
          },
          {
            code: this.$appConstants.transaction.types.immediate,
            description: 'Immediate',
          },
        ],
        'he-IL': [
        {
            code: this.$appConstants.transaction.types.regularDeal,
            description: 'עסקה רגילה',
          },
          {
            code: this.$appConstants.transaction.types.installments,
            description: 'תשלומים',
          },
          {
            code: this.$appConstants.transaction.types.credit,
            description: 'קרדיט',
          },
          {
            code: this.$appConstants.transaction.types.immediate,
            description: 'חיוב מיידי',
          },
        ],
      },      
    };
  },
  created() {
    if (this.selectedItem) {
      this.model.quickDateFilter = this.selectedItem.code;
    }
  },  
  async mounted() {
    this.dictionaries = await this.$api.dictionaries.getTransactionDictionaries();
  },
  methods: {
    resetQuickDateFilter() {
      this.model.quickDateFilter = null;
      this.resetValidation;
    },
    // updateDateFromTo(val) {
    //   switch (val) {
    //     case "today":
    //       this.$refs.dateFromTo.data.dateFrom = moment().startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().endOf('day');          
    //       break;
    //     case "yesterday":
    //       this.$refs.dateFromTo.data.dateFrom = moment().subtract(1, 'days').startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().subtract(1, 'days').endOf('day');
    //       break;
    //     case "thisWeek":
    //       this.$refs.dateFromTo.data.dateFrom = moment().startOf('week').startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().endOf('day');
    //       break;
    //     case "lastWeek":
    //       this.$refs.dateFromTo.data.dateFrom = moment().subtract(1, 'weeks').startOf('week').startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().startOf('week').subtract(1, 'days').endOf('day');
    //       break;
    //     case "last30Days":
    //       this.$refs.dateFromTo.data.dateFrom = moment().subtract(29, 'days').startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().endOf('day');
    //       break;
    //     case "thisMonth":
    //       this.$refs.dateFromTo.data.dateFrom = moment().startOf('month').startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().startOf('month').endOf('month').endOf('day');
    //       break;
    //     case "lastMonth":
    //       this.$refs.dateFromTo.data.dateFrom = moment().subtract(1, 'months').startOf('month').startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().subtract(1, 'months').startOf('month').endOf('month').endOf('day');
    //       break;
    //     case "last3Months":
    //       this.$refs.dateFromTo.data.dateFrom = moment().startOf('month').subtract(3, 'months').startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().subtract(1, 'months').startOf('month').endOf('month').endOf('day');
    //       break;
    //     case "thisYear":
    //       this.$refs.dateFromTo.data.dateFrom = moment().startOf('year').startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().endOf('day');
    //       break;
    //     case "lastYear":
    //       this.$refs.dateFromTo.data.dateFrom = moment().subtract(1, 'years').startOf('year').startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().startOf('year').subtract(1, 'days').endOf('day');
    //       break;
    //     default:
    //       this.$refs.dateFromTo.data.dateFrom = moment().startOf('day');
    //       this.$refs.dateFromTo.data.dateTo = moment().endOf('day');
    //       break;
    //   }
    //   this.$refs.dateFromTo.data.dateFrom = this.$formatDate(this.$refs.dateFromTo.data.dateFrom);
    //   this.$refs.dateFromTo.data.dateTo = this.$formatDate(this.$refs.dateFromTo.data.dateTo);
    //   this.model.dateFrom = this.$refs.dateFromTo.data.dateFrom;
    //   this.model.dateTo = this.$refs.dateFromTo.data.dateTo;
    // }
  },
  computed: {
    ...mapState({
      availableCurrencies: state => state.settings.availableCurrencies,
      currentLocale: state => state.localization.currentLocale,
    }),
    transactionTypeEnum() {
      return this.transactionTypeEnumLang[this.currentLocale];
    },
    selectedItem() {
      return this.selectedPeriod != null ? this.dictionaries.quickDateFilterTypeEnum.find(
        (item) => item.code === this.selectedPeriod
      ) : null;
    },    
  },
  watch: {
    selectedPeriod(newValue) {
      if (newValue && this.selectedItem && this.model.quickDateFilter !== newValue) {
        this.model.quickDateFilter = newValue;
      }
    },
    'this.$refs.dateFromTo' (newValue) {
      this.model.quickDateFilter = null;
      this.resetValidation;
    },
    // 'model.quickDateFilter' (newValue) { 
    //   if (newValue != undefined) {
    //       this.updateDateFromTo(newValue);
    //   }      
    // },
  },  
};
</script>